import { render, staticRenderFns } from "./DirectBookingsCard.vue?vue&type=template&id=47231f1f&"
import script from "./DirectBookingsCard.vue?vue&type=script&lang=js&"
export * from "./DirectBookingsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports